// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-edit-appoinment',
//   templateUrl: './edit-appoinment.component.html',
//   styleUrls: ['./edit-appoinment.component.scss']
// })
// export class EditAppoinmentComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControlName } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppoinmentserviceService } from '../add-appoinments/appoinmentservice.service';
import { Notification } from '../../../core/Notifications/Notification';
import { forEachRight, values } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentExample1Component } from '../dialog-content-example1/dialog-content-example1.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { ShowdoctorComponent } from '../showdoctor/showdoctor.component';
import { ShowhospitalComponent } from '../showhospital/showhospital.component';
import { EditdialogComponent } from './editdialog/editdialog.component';


@Component({
  selector: 'app-edit-appoinment',
  templateUrl: './edit-appoinment.component.html',
  styleUrls: ['./edit-appoinment.component.scss']
})
export class EditAppoinmentComponent implements OnInit {
  doctors: any;
  complaint: any;
  diseases: any;
  symptoms: any;
  appoinmentForm: FormGroup;
  private json: any;
  private filterJson: any;
  i = 0;
  result: any;
  toppings: any;
  ClinicalDiscipline: any;
  appoinment: any;
  doctordd: any;
  complaintselected: any;
  symptomsselected: any;
  diseasesselected: any;
  allergy: any;
  allergysignsselected: any;
  patnt_id: any;
  testing = [{ smst_Id: 1, smst_Code: 'SYM1', smst_Name: 'Fever' }, { smst_Id: 2, smst_Code: 'SYM1', smst_Name: 'Fever' }]
  userTestStatus: { smst_Id: string, smst_Code: string, smst_Name: string }[];
  editappon: any = ['e'];
  appnget: any;
  Height: any;
  data: any;
  test: any;

  constructor(public dialog: MatDialog, private formBuilder: FormBuilder, private AppoinmentserviceService: AppoinmentserviceService, private router: Router,
    private notify: Notification, private route: ActivatedRoute,) {
    this.appoinmentForm = this.formBuilder.group({
      'appt_Id':[''],
      'symptoms': [''],
      'diseasesDtl': [''],
      'complaint': [''],
      'allergySigns_DTL': [''],
      'Weight': [''],
      'Height': [''],
      'select_day': [''],
      'select_FrmTime': [''],
      'select_toTime': [''],
      'appt_DO_Id_FK': [''],
      'Appt_DateTime': [''],
      'appt_PatientId_FK':['']
    });

  }

  ngOnInit(): void {
    let id = +this.route.snapshot.params['id'];
    this.route.params.subscribe((params: Params) => {
      id = +params['id'];
      this.patnt_id = id;
      console.log('id' + this.patnt_id)
    });
    this.get_appoinbyid(this.patnt_id)

    // this.AppoinmentserviceService.get_appoinment()
    //   .subscribe((data: any) => {
    //     console.log('api')
    //     console.log(data)
    //     this.editappon = data;
    //     this.appoinmentForm.controls['cD_Id'].setValue(data[0].cD_Id);
    //     this.appoinmentForm.controls['cpT_MST_Id_FK'].setValue(data[0].cpT_MST_Id_FK);
    //     this.appoinmentForm.controls['symptomslist'].setValue(data[0].symptoms);
    //     this.appoinmentForm.controls['diseasesDtl'].setValue(data[0].diseasesDtl);
    //     this.appoinmentForm.controls['weight'].setValue(data[0].appt_PA_Weight);
    //     this.appoinmentForm.controls['height'].setValue(data[0].appt_PA_Height);
    //     this.appoinmentForm.controls['select_date'].setValue(data[0].select_date);
    //     this.appoinmentForm.controls['select_FrmTime'].setValue(data[0].select_FrmTime);
    //     this.appoinmentForm.controls['select_toTime'].setValue(data[0].select_toTime);
    //     this.appoinmentForm.controls['appt_DO_Id_FK'].setValue(data[0].appt_DO_Id_FK);
    //     //this.appoinmentForm.controls['appt_Id'].setValue(data[0].appt_Id);
    //     //this.appoinmentForm.value.symptomslist=data[0].symptomslist
    //     console.log(data[0].symptomslist)

    //     this.appoinmentForm.patchValue({
    //       symptomslist: data[0].symptomslist[0].syM_MST_Id_FK,
    //     });
    //     console.log('test0')
    //     console.log(this.appoinmentForm.value.symptomslist)
    //   })
    // console.log('test')
    // console.log(this.appoinmentForm.value.symptomslist)


    this.get_doctors();
    this.get_complaint();
    this.get_diseases();
    this.get_symptoms();
    this.get_Discipline();
    this.Get_Allergy();
    this.complaintselected = this.appoinmentForm.value.complaint
    this.symptomsselected = this.appoinmentForm.value.symptoms
    this.diseasesselected = this.appoinmentForm.value.diseasesDtl
    this.allergysignsselected = this.appoinmentForm.value.allergySigns_DTL

  }

  public objectComparisonFunctioncomplaint = function (option, value): boolean {
    return option.cpT_Id === value.cpT_Id;
  }
  public objectComparisonFunctionsymptoms = function (option, value): boolean {
    return option.smst_Id === value.smst_Id;
  }
  public objectComparisonFunctionPresentIlleness = function (option, value): boolean {
    return option.id === value.id;
  }
  public objectComparisonFunctionallergysigns = function (option, value): boolean {
    return option.al_Id === value.al_Id;
  }

  //Complaint
  //toppingsControl = new FormControl([]);
  // toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemovedcomplaint(topping: string) {
    const toppings = this.appoinmentForm.value.complaint;
    this.removeFirst(toppings, topping);
    this.appoinmentForm.controls['complaint'].setValue(toppings);
  }


  //symptoms
  // toppingsControl1 = new FormControl([]);
  // toppingList1: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemovedsymptoms(topping: string) {
    const toppings = this.appoinmentForm.value.symptoms;
    this.removeFirst(toppings, topping);
    this.appoinmentForm.controls['symptoms'].setValue(toppings);
  }
 
  

  //diseases
  // toppingList2: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

  onToppingRemoveddiseases(topping: string) {
    const toppings = this.appoinmentForm.value.diseasesDtl;
    this.removeFirst(toppings, topping);
    this.appoinmentForm.controls['diseasesDtl'].setValue(toppings);
  }

  //allerges
  onToppingRemovedallergysigns(topping: string) { 
    const toppings = this.appoinmentForm.value.allergySigns_DTL;
    this.removeFirst(toppings, topping);
    this.appoinmentForm.controls['allergySigns_DTL'].setValue(toppings);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }


  saveForm() {
    const formData = new FormData();
    const ass_date = new DatePipe('en-US').transform(this.appoinmentForm.value.select_date, 'dd/MM/yyyy')
    // formData.append('cpT_MST_Id_FK', this.appoinmentForm.value.cpT_MST_Id_FK);
    // formData.append('symptoms', this.appoinmentForm.value.symptoms);
    // formData.append('diseasesDtl', this.appoinmentForm.value.diseasesDtl);
    // formData.append('appt_PA_Weight', this.appoinmentForm.value.appt_PA_Weight);
    // formData.append('appt_PA_Height', this.appoinmentForm.value.appt_PA_Height);
    // formData.append('select_date', ass_date);
    // formData.append('select_FrmTime', this.appoinmentForm.value.select_FrmTime);
    // formData.append('select_toTime', this.appoinmentForm.value.select_toTime);
    // formData.append('appt_DO_Id_FK', this.appoinmentForm.value.appt_DO_Id_FK);
    // console.log('Form data is', this.appoinmentForm.value);

    // this.AppoinmentserviceService
    // .Post_appoinment(this.appoinmentForm.value).subscribe((data: any) => {
    //   this.appoinment = data
    //   // this.openDialog();
    //   console.log(this.appoinment);
    // })
    // this.notify.successmsg("Appoinment" + " fixed Successfully.");
    // this.router.navigate(["/base/patient/Appoinment"]);
    this.appoinmentForm.controls['Appt_DateTime'].setValue(this.appoinmentForm.value.select_day);
    console.log(this.appoinmentForm.value)
    this.AppoinmentserviceService
    .Update_appoinment(this.appoinmentForm.value)
    .subscribe((res)=>{
      this.notify.successmsg("Appointment Updated Successfully")
    })
  }
  // openDialog() {
  //   const dialogRef = this.dialog.open(DialogContentExample1Component);
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }
  resetForm() {
    this.appoinmentForm.reset();
  }

  get_doctors() {
    this.AppoinmentserviceService.get_doctors()
      .subscribe((data) => {
        this.doctors = data
        console.log(this.doctors)
      })
  }

  get_complaint() {
    this.AppoinmentserviceService.get_complaint()
      .subscribe((data) => {
        this.complaint = data
        console.log(this.complaint)
      })
  }

  get_diseases() {
    this.AppoinmentserviceService.get_diseases()
      .subscribe((data) => {
        this.diseases = data
        console.log(this.diseases)
      })
  }

  get_symptoms() {
    this.AppoinmentserviceService.get_symptoms()
      .subscribe((data) => {
        this.symptoms = data
        console.log(this.symptoms)
      })
  }

  get_Discipline() {
    this.AppoinmentserviceService.get_Discipline()
      .subscribe((data) => {
        this.ClinicalDiscipline = data
        console.log(this.ClinicalDiscipline)
      })
  }

  get_doctordd() {
    this.AppoinmentserviceService.get_doctordd()
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }

  Get_Allergy() {
    this.AppoinmentserviceService.Get_Allergy()
      .subscribe((data) => {
        this.allergy = data
      })
  }

  get_appoinbyid(patnt_id) {
    this.AppoinmentserviceService.get_appoinbyId(patnt_id)
      .subscribe((data) => {
        this.appnget = data
        console.log('appnget' , this.appnget)
        this.appoinmentForm.patchValue({
          Height: this.appnget[0].appt_PA_Height,
          Weight: this.appnget[0].appt_PA_Weight,
          complaint: this.appnget[0].complaintslist,
          symptoms: this.appnget[0].symptomslist,
          diseasesDtl: this.appnget[0].diseaseslist,
          allergySigns_DTL: this.appnget[0].allergylist,
          select_day: this.appnget[0].select_date,
          select_FrmTime: this.appnget[0].select_FrmTime,
          select_toTime: this.appnget[0].select_toTime,
          appt_DO_Id_FK:this.appnget[0].appt_DO_Id_FK,
          appt_Id: this.appnget[0].appt_Id,
          appt_PatientId_FK: this.appnget[0].appt_PatientId_FK
        });
        this.test=this.appnget[0].appt_DO_Name
      })
  }

  showdoctr(){
    const dialogRef = this.dialog.open(ShowdoctorComponent,
      {
        height: '65%',
        width: '65%',
      });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result != undefined) {
        this.test=result.dO_Name;
        this.appoinmentForm.controls['appt_DO_Id_FK'].setValue(result.dO_Id);
      }
    //   setTimeout(() => {
    //     window.location.reload();
    // }, 2000);
    });
  }

  showhosptl(){
    const dialogRef = this.dialog.open(ShowhospitalComponent,
      {
        height: '65%',
        width: '65%',
      });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result != undefined) {
        this.test=result.dO_Name;
        this.appoinmentForm.controls['appt_DO_Id_FK'].setValue(result.dO_Id);
      }
    //   setTimeout(() => {
    //     window.location.reload();
    // }, 2000);
    });
  }

  editform(){
    const dialogRef = this.dialog.open(EditdialogComponent,
      {
        height: '35%',
        width: '55%',
        data:this.appoinmentForm.value,
      });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      //   setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    });
  }

}


